namespace Areas.CollaborationAreas {
    "use strict";
   
    let selected: Selected = new Selected();

    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/CollaborationAreas/Users/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }
    
    export function fillId(e) {

        const dataGrid = Areas.getGrid("CollaborationAreaUsersGrid");
        const CollaborationAreaId = dataGrid.option('KeyId');

        e.data.CollaborationAreaId = CollaborationAreaId;
        e.data.userRole = "FullAccess";
        e.data.isActive = true;

    }

    
}



